import { render, staticRenderFns } from "./RepairRouter.vue?vue&type=template&id=8da4e5f2&"
import script from "./RepairRouter.vue?vue&type=script&lang=js&"
export * from "./RepairRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports